import ResourceLinkModel from '../../generated/types/model/resource/ResourceLinkModel';

export default class ResourceLinkViewModel extends ResourceLinkModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
